import React, { useContext, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { HomeContext } from '../Context/HomeContext';
import { Helmet } from 'react-helmet';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './Navbar.css';
import './Search.css'

const Navbar = () => {
  const { homeData } = useContext(HomeContext);
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(null);

  const categories = homeData?.allCategories ? Object.values(homeData.allCategories) : [];
  const metaTags = homeData?.meta_tags || '';

  const closeNavbar = () => {
    const navbar = document.getElementById('navbarSupportedContent');
    if (navbar && navbar.classList.contains('show')) {
      const bsCollapse = bootstrap.Collapse.getInstance(navbar);
      if (bsCollapse) bsCollapse.hide();
    }
  };

  const handleCategoryClick = (slug) => {
    setOpenDropdown(null);
    closeNavbar();
    navigate(`/category/${slug}`);
  };

  const handleToggle = (slug, e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenDropdown(prev => (prev === slug ? null : slug));
  };

  const today = new Date();
  const monthYear = today.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  const dayName = today.toLocaleDateString('en-US', { weekday: 'long' });

  return (
    <>
      {metaTags && (
        <Helmet>
          <meta name="description" content={metaTags.description} />
          <meta property="og:title" content={metaTags.title} />
          <meta property="og:description" content={metaTags.description} />
          <meta
            property="og:image"
            content={metaTags.image || (process.env.PUBLIC_URL + "/default-og-image.jpg")}
          />
          <meta property="og:url" content={window.location.href} />
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
      )}

      <div className="head1">
        <div>
          <NavLink className="navbar-brand m-0" to="/">
            <img
              src={process.env.PUBLIC_URL + "/logo1.png"}
              width="40px"
              height="40px"
              alt="StreamPlay Network"
            
              className="imglogo"
            />
          </NavLink>
          &nbsp;&nbsp;
          <span className='monthYear'>{monthYear}</span> &nbsp;
          <span className='dayName'>{dayName}</span>
        </div>

        <div className="searchBar">
          <form
            className="d-flex mx-auto"
            role="search"
            style={{ maxWidth: '900px', width: '100%' }}
            onSubmit={(e) => {
              e.preventDefault();
              const query = e.target.search.value.trim();
              if (query) {
                closeNavbar();
                navigate(`/search?q=${encodeURIComponent(query)}`);
              }
            }}
          >
            <input
              className="form-control me-2 rounded-pill px-4"
              name="search"
              type="search"
              placeholder="Search..."
            />
            <button className="btn btn-outline-light rounded-pill px-4 searchbtn" type="submit">
              Search
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Navbar;
